import { render, staticRenderFns } from "./TipoConvenioPage.vue?vue&type=template&id=11c5c2f2"
import script from "./TipoConvenioPage.js?vue&type=script&lang=js&external"
export * from "./TipoConvenioPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports